import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { startupRouteReady } from "../../lib/startupTelemetry.js";

/** The authenticated 404 uses the loaded shell vocabulary and has no lazy tab. */
export function RouteNotFoundView({ onGoHome }: { onGoHome: () => void }) {
  const { t, ready } = useTranslation("shell");
  useEffect(() => { if (ready) startupRouteReady(); }, [ready]);
  // Shell already renders the page's h1.
  return <section className="panel route-not-found">
    <p>{t("notFound.body")}</p>
    <p><button type="button" onClick={onGoHome}>{t("notFound.action")}</button></p>
  </section>;
}
